export default {
  token: (() => {
    try {
      const jwt = localStorage.getItem("jwt");
      return jwt || null;
    } catch (error) {
      console.warn("Error getting JWT from localStorage:", error);
      return null;
    }
  })(),
  changed: false,
  tablename: "",
  changedId: null,
  tableHeaders: [],
  tableContent: [],
  confirmDialogShow: false,
  ErrorDialogShow: false,
  ServerError: "",
  SnackHandler: {},
  savedState: null,
  hirejobs: [],
  filter: "",
  nav: false,
  HygienistForDispute: [],
  LocationForDispute: [],
  HygienistComments: [],
  LocationComments: [],
  countDays: 3,
  PaymentIntegrities: [],
  dueYet: "",
  sortBy: "",
  sortDesc: false,
  preparedDataToSave: [],
  selectedLocationId: null as number | null,
  selectedInvoiceId: null as number | null,
  selectedHygienistId: null as number | null
};
